import React, { useCallback } from "react";
import { useAuth } from "../../utils/AuthContext";
import styles from "./FavouriteButton.module.scss";
import StarFill from "./StarFill.svg";
import StarLine from "./StarLine.svg";
import Button from "../Button/StandardButton/Button";

interface FavouriteButtonProps {
  id: string;
  className?: string;
}

const FavouriteButton = ({ id, className }: FavouriteButtonProps) => {
  const { userInfo, addFavourite, removeFavourite } = useAuth();
  const { favourites } = userInfo;
  const starred = favourites?.findIndex(f => f.id === id) !== -1;

  const handleFavouriteClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      if (starred) {
        await removeFavourite(id);
      } else {
        await addFavourite(id);
      }
    },
    [id, addFavourite, starred, removeFavourite]
  );

  if (!favourites) {
    return null;
  }

  return (
    <Button
      onClick={handleFavouriteClick}
      className={`${styles.favouriteButton} ${className}`}
    >
      {starred ? (
        <img
          className={styles.favouriteIcon}
          src={StarFill}
          alt="Filled favourite icon"
        />
      ) : (
        <img
          className={styles.favouriteIcon}
          src={StarLine}
          alt="Unfilled favourite icon"
        />
      )}
    </Button>
  );
};

export default FavouriteButton;
